function checkTab(){
    if(this.item.subtab){
        this.ctab=this.item.subtab;
    }
}
export {
    checkTab
}
